import React from "react";
import { Autocomplete, TextField } from "@mui/material";

// Cached list of IANA timezone names. Browsers without
// Intl.supportedValuesOf fall back to a curated set covering the regions
// Eventegration events actually run in.
function loadTimezones() {
  try {
    if (typeof Intl.supportedValuesOf === "function") {
      return Intl.supportedValuesOf("timeZone");
    }
  } catch (_) {}
  return [
    "UTC",
    "Asia/Kolkata",
    "Asia/Dubai",
    "Asia/Muscat",
    "Asia/Riyadh",
    "Asia/Singapore",
    "Asia/Bangkok",
    "Asia/Tokyo",
    "Europe/London",
    "Europe/Paris",
    "Europe/Berlin",
    "Europe/Moscow",
    "Africa/Cairo",
    "America/New_York",
    "America/Los_Angeles",
    "Australia/Sydney",
  ];
}

const TIMEZONES = loadTimezones();

export function browserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch (_) {
    return "UTC";
  }
}

export default function TimezoneSelect({
  value,
  onChange,
  label = "Timezone",
  error,
  helperText,
  size,
  fullWidth = true,
}) {
  return (
    <Autocomplete
      options={TIMEZONES}
      value={value || null}
      onChange={(_, v) => onChange(v || null)}
      autoHighlight
      size={size}
      fullWidth={fullWidth}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="standard"
          error={!!error}
          helperText={helperText || "IANA name, e.g. Asia/Kolkata"}
        />
      )}
    />
  );
}
